import { TextField, MenuItem, Select, FormControl, InputLabel, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const ACCENT = "#c0392b";

export default function LWFMasterFilter({ fields = [], values, setValue, isOpen, onClose, onApply, onClear }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: 1200,
        }}
      />

      {/* Drawer */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: 320,
          backgroundColor: "#fff",
          zIndex: 1300,
          display: "flex",
          flexDirection: "column",
          boxShadow: "-4px 0 24px rgba(0,0,0,0.15)",
        }}
      >
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between px-3 py-3" style={{ borderBottom: "1px solid #e0e0e0" }}>
          <span style={{ fontSize: 17, fontWeight: 600 }}>Filters</span>
          <IconButton size="small" onClick={onClose} aria-label="Close filters">
            <Close fontSize="small" />
          </IconButton>
        </div>

        {/* Scrollable body */}
        <div style={{ flex: 1, overflowY: "auto" }} className="py-2">
          {fields.map((field) => (
            <FieldRenderer key={field.key} field={field} values={values} setValue={setValue} />
          ))}
        </div>

        {/* Footer */}
        <div className="d-flex gap-2 px-3 py-3" style={{ borderTop: "1px solid #e0e0e0" }}>
          <button className="btn btn-danger flex-fill fw-500" style={{ backgroundColor: ACCENT, borderColor: ACCENT }} onClick={onApply}>
            Apply
          </button>
          <button className="btn btn-secondary flex-fill" onClick={onClear}>
            Clear
          </button>
        </div>
      </div>
    </>
  );
}

function FieldRenderer({ field, values, setValue }) {
  switch (field.type) {
    case "text":
      return <TextFieldRow field={field} values={values} setValue={setValue} />;
    case "select":
      return <SelectContent field={field} values={values} setValue={setValue} />;
    default:
      return null;
  }
}

function TextFieldRow({ field, values, setValue }) {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setValue(field.key, val);
    }
  };

  return (
    <div className="px-3 py-2">
      <TextField
        fullWidth
        size="small"
        label={field.label}
        value={values[field.key] || ""}
        onChange={handleChange}
        variant="outlined"
        inputProps={{ inputMode: "decimal" }}
      />
    </div>
  );
}


function SelectContent({ field, values, setValue }) {
  return (
    <div className="px-3 py-2">
      <FormControl fullWidth size="small">
        <InputLabel>{field.label}</InputLabel>
        <Select value={values[field.key] ?? ""} label={field.label} onChange={(e) => setValue(field.key, e.target.value)}>
          <MenuItem value="">
            <em>Select {field.label}</em>
          </MenuItem>
          {field.options.map((opt) => {
            const isObject = typeof opt === "object" && opt !== null;
            const optionValue = isObject ? opt.value : opt;
            const optionLabel = isObject ? opt.label : opt;
            return (
              <MenuItem key={optionValue} value={optionValue}>
                {optionLabel}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}